import { Heading4 } from 'app/components';
import Accordion from 'app/components/Accordion/Accordion';
import { ReviewStepBox } from '../../styles';
import CreditSimulatorSchedule from '../../../SimulationV2Step/CreditSimulatorV2/CreditSimulatorSchedule';
import { TProducts } from 'modules/products/context';
import {
  TSimulatorV2Request,
  TSimulatorV2Response,
} from 'app/services/simulatorHttpServiceV2';

interface ReviewStepInstallmentsAccordionProps {
  isOpen: boolean;
  onClick: () => void;
  product: TProducts | null;
  simulationV2Request: TSimulatorV2Request | null;
  simulationV2: TSimulatorV2Response | null;
  originalSimulationV2RequestRef: React.MutableRefObject<TSimulatorV2Request | null>;
  handleDisbursementDateChangeV2: (date: string) => void;
}

const ReviewStepInstallmentsAccordion = ({
  isOpen,
  onClick,
  product,
  simulationV2Request,
  simulationV2,
  originalSimulationV2RequestRef,
  handleDisbursementDateChangeV2,
}: ReviewStepInstallmentsAccordionProps) => {
  return (
    <ReviewStepBox marginTop="16px" marginBottom="16px" padding="24px 8px">
      <Accordion
        cleanStyle={true}
        isOpen={isOpen}
        title={<Heading4>Parcelas</Heading4>}
        onClick={onClick}
      >
        <CreditSimulatorSchedule
          noHeader
          product={product}
          simulationRequest={
            originalSimulationV2RequestRef.current || simulationV2Request
          }
          simulationResponse={simulationV2}
          simulateWithDifferentDisbursementDate={handleDisbursementDateChangeV2}
        />
      </Accordion>
    </ReviewStepBox>
  );
};

export default ReviewStepInstallmentsAccordion;
